import React from 'react';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import styles from './ButtonArrowBack.module.scss';

export default function ButtonArrowBack(props: any) {

    const handleClickEvent = (): void => {
        if (props?.handleClick) {
            props.handleClick();
        }
    }

    return (
        <div className={!props.isClickable ? styles.main_container : `${styles.main_container} ${styles.clickable}`} onClick={handleClickEvent}>
            <KeyboardArrowLeftIcon fontSize='small' className={styles.arrow} />
        </div>
    )
}
